'use client';

import { c as _c } from "react/compiler-runtime";
import BackgroundImage from '@components/background-image/BackgroundImage';
import Gradient_2 from '@images/gradients/gradient_2.webp';
import Gradient_2_mob from '@images/gradients/gradient_2_mob.webp';
import Gradient_3 from '@images/gradients/gradient_3.webp';
import Gradient_3_mob from '@images/gradients/gradient_3_mob.webp';
import Gradient_4 from '@images/gradients/gradient_4.webp';
import Bgr from '@images/renders/infrastructure_images/Infra_Desktop_Webp/4.webp';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { showAnimate } from '@lib/tools/utils';
import classNames from 'classnames';
import DOMPurify from 'isomorphic-dompurify';
import NextImage from 'next/image';
import { useLayoutEffect, useRef } from 'react';
import style from './ThirdScreenInfra.module.scss';
const dompurifyConfig = {
  FORBID_TAGS: ['script', 'style'],
  FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick']
};
export const list = [{
  id: 0,
  text: 'Учиться на свежем воздухе'
}, {
  id: 1,
  text: 'Прокачивать спортивные навыки'
}, {
  id: 2,
  text: 'Укреплять командный дух         на вечнозелёном поле'
}, {
  id: 3,
  text: 'Полноценно отдыхать от уроков         на увлекательных площадках'
}, {
  id: 4,
  text: 'Устраивать школьные обеды        на холмистых лужайках'
}];
function ThirdScreenInfra(t0) {
  const $ = _c(18);
  const {
    isMobile
  } = t0;
  const svgRef = useRef(null);
  const titleRef = useRef(null);
  const boxRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (svgRef) {
        let st5 = null;
        const element = svgRef.current;
        setTimeout(() => {
          st5 = ScrollTrigger.create({
            trigger: element,
            start: "center center",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            scrub: true,
            pin: false
          });
          showAnimate(titleRef, titleRef.current);
          showAnimate(boxRef, boxRef.current);
          return () => {
            st5.kill();
          };
        }, 1000);
      }
    };
    t2 = [svgRef, isMobile];
    $[0] = isMobile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const t3 = !isMobile ? Gradient_2 : Gradient_2_mob;
  let t4;
  if ($[3] !== t3) {
    t4 = <NextImage loading="lazy" decoding="async" src={t3} alt="gradient" className={style.thirdScreenGradient} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !isMobile ? Gradient_3 : Gradient_3_mob;
  let t6;
  if ($[5] !== t5) {
    t6 = <NextImage loading="lazy" decoding="async" src={t5} alt="gradient" className={style.thirdScreenGradientBottom} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isMobile) {
    t7 = !isMobile ? <NextImage loading="lazy" decoding="async" src={Gradient_4} alt="gradient" className={style.thirdScreenGradientBottom_2} /> : null;
    $[7] = isMobile;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <>{t4}{t6}{t7}</>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <BackgroundImage className={style.thirdScreenImg} src={Bgr} name="bgr_3" imagePlug={Bgr} />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div ref={titleRef} className={style.thirdScreenTitle}><p className="will-show">Приходите </p><p className="will-show">поддержать своих</p><p className="will-show">чемпионов</p></div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ul ref={boxRef} className={style.thirdScreenInfoContainer}>{list?.map(_temp)}</ul>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t8) {
    t12 = <div data-scroll={true} className={style.thirdScreenContainer} ref={svgRef} id="location">{t8}{t9}{t10}{t11}</div>;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
function _temp(item) {
  return <li key={item.id} className={classNames(style.thirdScreenInfoBox, "will-show")}><div className={style.thirdScreenInfoDescrip} dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(item.text, dompurifyConfig)
    }} /></li>;
}
export default ThirdScreenInfra;